import React from 'react';
import { EmployeeAccess } from './EmployeeAccess';
import { SurveyResponse } from './SurveyResponse';
import { ContentContainer } from './ContentContainer';
import { SurveysDashboard } from './SurveysDashboard';
import { usePsychosocialAvaliationContext } from './context';
import { SuccessScreen } from './SurveyResponse/components/SuccessScreen';
import { useGetParticipationAnswers } from '@/views/PsychosocialReport/hooks/useGetParticipationAnswers';

export function NavigationManager() {
	const { step, isAuthenticated, surveyData, participationId, isSurveyCompleted } =
		usePsychosocialAvaliationContext();

	const { data: participationAnswers } = useGetParticipationAnswers({
		participation_id: participationId ?? ''
	});

	return (
		<ContentContainer>
			{step === 0 && <EmployeeAccess />}
			{!isSurveyCompleted && step === 1 && isAuthenticated && surveyData && (
				<SurveyResponse
					initialFormValues={participationAnswers?.answers || {}}
					percentageCompleted={participationAnswers?.percentage_completed || 0}
				/>
			)}
			{isSurveyCompleted && step === 1 && <SuccessScreen />}
			{step === 2 && <SurveysDashboard />}
		</ContentContainer>
	);
}
